import { throttle } from './common'

function resize() {
    const vertical = window.innerWidth - document.documentElement.clientWidth
    const horizontal =
        window.innerHeight - document.documentElement.clientHeight
    document.documentElement.style.setProperty(
        '--window-width',
        window.innerWidth,
    )
    document.documentElement.style.setProperty(
        '--window-height',
        window.innerHeight,
    )
    document.documentElement.style.setProperty(
        '--vertical-scrollbar-width',
        `${vertical}px`,
    )
    document.documentElement.style.setProperty(
        '--horizontal-scrollbar-width',
        `${horizontal}px`,
    )
}

window.addEventListener('scroll', throttle(resize, 500))
